<template>
    <information-popup modal-id="inscriptionExamplesPopup">
        <template slot="header">Inscription Examples</template>
        <slot>
            <div class="modal-body inscription-modal">
                <div class="row">
                    <div class="col-sm-3">
                        <h3 class="text-danger">ANNIVERSARY</h3>
                        <p><strong>4x8</strong></p>
                        <p>CELEBRATING OUR</p>
                        <p>5TH ANNIVERSARY</p>
                        <p>JILL & TOM CABE</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>UB FOREVER</p>
                        <p>IN OUR HEARTS</p>
                        <p>TONY & NINA PARK</p>
                        <p>MET AT UB - 1987</p>
                        <p>MARRIED - 1992</p>
                        <p>GO BULLS!</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>WE LOVE UB!</p>
                        <p>WHERE WE BUMPED</p>
                        <p>INTO EACH OTHER</p>
                        <p>MIT & JAN GREER</p>
                        <br/>
                        <p><strong>12x12 Logo Brick</strong></p>
                        <p>OUR JOURNEY</p>
                        <p>BEGAN AT</p>
                        <p>UNIVERSITY AT</p>
                        <p>BUFFALO</p>
                        <p>28 YEARS AGO!</p>
                        <p>LIZ & BRAD ZEPP</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">GRADUATION</h3>
                        <p><strong>4x8</strong></p>
                        <p>EMMA DAVIS</p>
                        <p>ENGLISH LIT</p>
                        <p>CLASS OF 2014</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>TO OUR DAUGHTER</p>
                        <p>EMILY BROWN</p>
                        <p>CONGRATULATIONS</p>
                        <p>ON YOUR</p>
                        <p>GRADUATION</p>
                        <p>LOVE, MOM & DAD</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>MOM & DAD</p>
                        <p>I DID IT!</p>
                        <p>UB CLASS OF '12</p>
                        <p>LOVE, ERIC</p>
                        <br/>
                        <p><strong>12x12 Logo Brick</strong></p>
                        <p>JEFFREY DAVIS</p>
                        <p>WE ALWAYS</p>
                        <p>BELIEVED IN YOU</p>
                        <p>AND WE ARE SO</p>
                        <p>PROUD OF YOUR</p>
                        <p>GRADUATION!</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">STUDENT ATHLETES</h3>
                        <p><strong>4x8</strong></p>
                        <p>ERIC HARPER</p>
                        <p>TIGHT END</p>
                        <p>1997 - 2001</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>THANK YOU</p>
                        <p>UB & DONORS</p>
                        <p>FOR THE HONOR</p>
                        <p>OF COMPETING &</p>
                        <p>AN EDUCATION</p>
                        <p>THOMAS FERRY</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>JOHNTHAN JONES</p>
                        <p>TRACK & FIELD</p>
                        <p>NAT. CHAMPION</p>
                        <p>SHOT PUT - 2015</p>
                        <br/>
                        <p><strong>12x12 Logo Brick</strong></p>
                        <p>FOREVER GRATEFUL</p>
                        <p>FOR THE CHANCE</p>
                        <p>TO PLAY FOR</p>
                        <p>COACH WEBBER</p>
                        <p>& UB VOLLEYBALL</p>
                        <p>JESSICA HARRIS</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">FAMILY</h3>
                        <p><strong>4x8</strong></p>
                        <p>UB FAMILY</p>
                        <p>LISA, TOM &</p>
                        <p>THE PIPER KIDS!</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>1 BIG UB FAMILY</p>
                        <p>MICHAEL - 1978</p>
                        <p>EMMA - 1979</p>
                        <p>SHAWN - 2012</p>
                        <p>JESSICA - 2018</p>
                        <p>THE HAMER FAMILY</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>BUFFALO</p>
                        <p>FAMILY FOREVER</p>
                        <p>MEG, RYAN & JOE</p>
                        <p>PETERSON</p>
                        <br/>
                        <p><strong>12x12 Logo Brick</strong></p>
                        <p>WE LOVE THE</p>
                        <p>BULLS!</p>
                        <p>BRENDA, JANE</p>
                        <p>THAD, JOEY</p>
                        <p>SHELBY & JANICE</p>
                        <p>MCCULLOCH</p>
                    </div>
                </div>
                <hr/>
                <div class="row">
                    <div class="col-sm-3">
                        <h3 class="text-danger">FATHER'S DAY</h3>
                        <p><strong>4x8</strong></p>
                        <p>DANNY PERRETTA</p>
                        <p>NUMBER ONE FAN!</p>
                        <p>NUMBER ONE DAD!</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>THE MOST HOPEFUL</p>
                        <p>BULLS FAN.</p>
                        <p>ALWAYS THERE TO</p>
                        <p>SUPPORT UB!</p>
                        <p>WE LOVE YOU DAD</p>
                        <p>JOSH & ANNA</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>LIKE FATHER</p>
                        <p>LIKE SON</p>
                        <p>BULLS FOREVER!</p>
                        <p>TY & TOM McCABE</p>
                        <br/>
                        <p><strong>12x12 Logo Brick</strong></p>
                        <p>IN HONOR OF</p>
                        <p>THE BEST FATHER</p>
                        <p>& THE ULTIMATE</p>
                        <p>UB FAN!</p>
                        <p>MICHAEL JONES</p>
                        <p>1969 - 2014</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">MOTHER'S DAY</h3>
                        <p><strong>4x8</strong></p>
                        <p>#1 MOTHER</p>
                        <p>MY LOVE ALWAYS</p>
                        <p>BETHANY MARSH</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>MARY WATERS</p>
                        <p>THE MOM WHO</p>
                        <p>GAVE HER LOVE</p>
                        <p>& SUPPORT SO I</p>
                        <p>COULD BE A BULL!</p>
                        <p>LOVE, AMANDA</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>HAPPY MOTHER'S</p>
                        <p>DAY MOM!</p>
                        <p>WE LOVE YOU!!!</p>
                        <p>JEN & DON BRADY</p>
                        <br/>
                        <p><strong>12x12 Logo Brick</strong></p>
                        <p>MEG MARSHALL</p>
                        <p>LOVES HER SONS</p>
                        <p>& THE BULLS!</p>
                        <p>ALL OUR LOVE,</p>
                        <p>MITCH & TOBY</p>
                        <p>MARSHALL</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">GENERAL</h3>
                        <p><strong>4x8</strong></p>
                        <p>UB ALUMNI</p>
                        <p>REESE DEMARC</p>
                        <p>- 2015 -</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>ERIC & JENNY</p>
                        <p>THOMPSON</p>
                        <p>SEASON TICKETS</p>
                        <p>SINCE 1991</p>
                        <p>WE LOVE OUR</p>
                        <p>UB FAMILY!</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>REMEMBERING</p>
                        <p>THE GOOD TIMES!</p>
                        <p>'74 & '75</p>
                        <p>GREG & KIM KNOLL</p>
                        <br/>
                        <p><strong>12x12 Logo Brick</strong></p>
                        <p>OUR STORY IS A</p>
                        <p>GOOD ONE, ALL</p>
                        <p>OUR MEMORIES</p>
                        <p>STRONG AND TRUE,</p>
                        <p>FOR TOGETHER WE</p>
                        <p>ARE FAMILY</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">INSPIRING</h3>
                        <p><strong>4x8</strong></p>
                        <p>UB ALWAYS</p>
                        <p>HOLDS OUR HEARTS</p>
                        <p>BRAXTON FAMILY</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>AMBER & LAUREN</p>
                        <p>SO PROUD OF OUR</p>
                        <p>GIRLS FOR BEING</p>
                        <p>THE FIRST BULLS</p>
                        <p>IN THE FAMILY</p>
                        <p>LOVE, MOM & DAD</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>IT ALL STARTED @</p>
                        <p>BUFFALO</p>
                        <p>FAMILY FOREVER</p>
                        <p>THE FRY FAMILY</p>
                        <br/>
                        <p><strong>12x12 Logo Brick</strong></p>
                        <p>UNIVERSITY</p>
                        <p>TRADITIONS</p>
                        <p>BRING FAMILIES</p>
                        <p>TOGETHER!</p>
                        <p>GO BULLS!</p>
                        <p>THE SHROLLS</p>
                    </div>
                </div>
                <hr/>
                <div class="row">
                    <div class="col-sm-3">
                        <h3 class="text-danger">REMEMBRANCE</h3>
                        <p><strong>4x8</strong></p>
                        <p>IN HONOR OF</p>
                        <p>BRENT DUNN</p>
                        <p>1944 - 2013</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>IN HONOR OF</p>
                        <p>GRANDPA GENE</p>
                        <p>UB ALUM - 1959</p>
                        <p>AND PROUD FAN</p>
                        <p>THANKS FOR ALL</p>
                        <p>THE MEMORIES!</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>DEDICATED TO</p>
                        <p>OUR ANGEL</p>
                        <p>IN THE STARS</p>
                        <p>MADELINE REED</p>
                        <br/>
                        <p><strong>12x12 Logo Brick</strong></p>
                        <p>IN MEMORY OF</p>
                        <p>MICHAEL HADLEY</p>
                        <p>LOST BUT NOT</p>
                        <p>FOGOTTEN!!</p>
                        <p>THANK YOU FOR</p>
                        <p>YOUR SERVICE</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">TEAM</h3>
                        <p><strong>4x8</strong></p>
                        <p>TRUE BLUE!</p>
                        <p>BUFFALO</p>
                        <p>BULLS FOREVER!</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>WHETHER IN THE</p>
                        <p>SUNSHINE, RAIN,</p>
                        <p>OR SNOW,</p>
                        <p>WE'LL BE HERE</p>
                        <p>FOR THE BULLS!</p>
                        <p>THE ANDERSONS</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>THE GAME STARTS</p>
                        <p>HERE!!</p>
                        <p>GO BULLS!</p>
                        <p>- THE PERRY'S -</p>
                        <br/>
                        <p><strong>12x12 Logo Brick</strong></p>
                        <p>GO UB!</p>
                        <p>WE ARE AT EVERY</p>
                        <p>FOOTBALL GAME!</p>
                        <p>YOUR LOYAL FANS</p>
                        <p>JOHN, EILEEN</p>
                        <p>& GRANDPA JOE</p>
                    </div>
                </div>
            </div>
        </slot>
    </information-popup>
</template>

<script type="text/jsx">
    import InformationPopup from '@/components/popup/information-popup.vue'; export default { name: 'inscription-examples', components:
    { 'information-popup': InformationPopup } }
</script>

<style lang="scss" scoped>
    .inscription-modal {
        h3,
        p {
            white-space: nowrap;
        }
    }
</style>



// WEBPACK FOOTER //
// InscriptionExamples.vue?0f452701